<div *ngIf="imageVisible" style="border: 1px dotted #ddd;
border-radius: 0px;padding: 15px 10px;" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">

        <div fxLayout="row" fxLayoutGap="10px">

            <span fxLayoutAlign="start center">
                {{value}}
                <button [attr.guide]="'whatsapp-pdf-btn-1' + '__' + sanitizedUrl" (click)="download()" color="warn" mat-icon-button type="button">
                    <mat-icon>download

                    </mat-icon>

                </button>

            </span>

            <ng-container fxLayoutAlign="end center">
                <button [attr.guide]="'whatsapp-pdf-btn-2' + '__' + sanitizedUrl" (click)="logo()" mat-raised-button>
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Upload</span>
                </button>

                <button [attr.guide]="'whatsapp-pdf-btn-3' + '__' + sanitizedUrl" *ngIf="value!=''" (click)="deleteImage()" mat-raised-button>delete</button>
            </ng-container>

        </div>
    </div>
</div>

<div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;"
    fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <calsoft-common-file-upload-pdf (fileUploadResult)=getResult($event) [type]="'whatsapp'" [fileSizeLimit]="fileSizeLimit" [allowedMimeType]="allowedMimeType">
    </calsoft-common-file-upload-pdf>
</div>